import { Box, useTheme } from "@mui/material";
import mapboxgl from "mapbox-gl";
import { useEffect, useRef } from "react";
import { AdProjectPhotoDto } from "../../../api/psc";
import {
    DefaultDarkMapStyles,
    DefaultMapStyles,
} from "../../../constants/ProjectConstants";

export default function AdProjectDetailLocation(props: {
    item: AdProjectPhotoDto;
}) {
    const map = useRef(null);
    const mapContainer = useRef(null);

    const theme = useTheme();

    const itemCenter = [props.item.longitude, props.item.latitude];

    useEffect(() => {
        initializeMap();
    }, []);

    const initializeMap = () => {
        const style =
            theme.palette.mode === "light"
                ? DefaultMapStyles
                : DefaultDarkMapStyles;

        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: style,
            center: itemCenter,
            zoom: 15,
        });

        if (map.current.loaded()) {
            adMarkerToMap();
        } else {
            map.current.on("load", () => {
                adMarkerToMap();
            });
        }
    };

    const adMarkerToMap = () => {
        new mapboxgl.Marker().setLngLat(itemCenter).addTo(map.current);
    };

    return (
        <Box
            sx={{ height: { xl: "calc(60vh)", xs: "calc(100vh - 48px)" } }}
            ref={mapContainer}
        ></Box>
    );
}
